import { render, staticRenderFns } from "./ProductFreeShippingInfo.vue?vue&type=template&id=3b277ca3"
import script from "./ProductFreeShippingInfo.vue?vue&type=script&lang=js"
export * from "./ProductFreeShippingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports